import { Injectable } from '@angular/core';
import { CrudService } from '../crud.service';
import { Story } from '../../models/story';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StoryService extends CrudService<Story> {
  protected basePath = 'story'; // Specific for BookmarkService
  public instanceType = 'story'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }

  async getByCategoryIds(categoryIds: string[]) {
    const headers = new HttpHeaders({
      'X-Category-Ids': JSON.stringify(categoryIds),
    });
    return await lastValueFrom(
      this.http.get<{ [key: string]: Story }>(
        `${this.getBaseUrl()}/categories`,
        { headers: headers }
      )
    );
  }
}
